import _ from 'lodash'

export default {
  name: 'payment',
  components: {},
  props: {
    payment: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  watch: {},
  computed: {
    isSuccess () {
      return !_.isEmpty(this.payment) && this.payment.success
    },
    isFailed () {
      return !_.isEmpty(this.payment) && this.payment.failed
    }
  },
  methods: {},
  mounted () {}
}
